/** Persists dashboard org pill so Creating a position can scope `company_id` to that client. */
export const DASHBOARD_POSITIONS_ORG_FILTER_KEY =
  "talentino.dashboard.positionsOrgFilter";

/**
 * Fired after the pill is persisted (same tab). SessionStorage "storage" does not fire locally.
 */
export const DASHBOARD_POSITIONS_ORG_FILTER_CHANGED_EVENT =
  "talentino:dashboard-positions-org-filter";

/**
 * When an agency user picked a concrete client org on the dashboard, use that id
 * for positions list/create so DB `company_id` lines up with filtered search.
 * @returns {string|undefined}
 */
export function readDashboardPositionsScopedClientCompanyId(isAgency) {
  if (!isAgency || typeof window === "undefined") return undefined;
  try {
    const raw = sessionStorage.getItem(DASHBOARD_POSITIONS_ORG_FILTER_KEY);
    if (!raw) return undefined;
    const trimmed = raw.trim();
    if (trimmed === "" || trimmed === "all") return undefined;
    if (trimmed.length > 128) return undefined;
    return trimmed;
  } catch {
    return undefined;
  }
}
